import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';

class EmisorFiscalCredentialslInfo extends Component {

  render() {
    const { razon_social = '', rfc = '' } = this.props.data;

    return (
      <Row>
        <Col>
          <span>
            <strong>Razón social: </strong>
            { razon_social }
          </span>

          <br />

          <span>
            <strong>RFC: </strong>
            { rfc }
          </span>

          <br />

          <span>
            <strong>Tipo de persona: </strong>
            { rfc.length === 12 ? 'Moral' : 'Física' }
          </span>
        </Col>
      </Row>
    )
  }
}

export default EmisorFiscalCredentialslInfo;